import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { ReactQueryDevtools } from 'react-query-devtools'
import { ReactQueryConfigProvider } from 'react-query'
import { App } from './App'
import { Loading } from 'components/Loading'
import { ErrorBoundary } from 'react-error-boundary'
import * as serviceWorker from './serviceWorker'
import { InternalError } from 'features/InternalError'
import { UserProvider } from 'context/user-context'
import './styles/base.scss'
import './i18n'

const ONE_HOUR = 1000 * 60 * 60

const queryConfig = {
  staleTime: ONE_HOUR,
  cacheTime: ONE_HOUR,
}

ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <ReactQueryConfigProvider config={queryConfig}>
      <Router>
        <ErrorBoundary FallbackComponent={InternalError}>
          <UserProvider>
            <App />
          </UserProvider>
        </ErrorBoundary>
      </Router>
      <ReactQueryDevtools initialIsOpen={false} />
    </ReactQueryConfigProvider>
  </Suspense>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
